import { render, staticRenderFns } from "./RomaBreadcrumbs.vue?vue&type=template&id=1c850408"
import script from "./RomaBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./RomaBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./RomaBreadcrumbs.vue?vue&type=style&index=0&id=1c850408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports